import { useMemo } from 'react';
import type { AnalyticsDataPoint } from '../../components/ChartContainer';
import { aggregateByGranularity } from '../../utils/aggregateByGranularity';

export function useUpsell(
    map: Map<string, { revenue: number; upsellCount: number }> | undefined,
    granularity: 'daily' | 'weekly' | 'monthly',
    currency: string,
): AnalyticsDataPoint[] {
    return useMemo(() => {
        if (!map) return [];
        const data = Array.from(map.entries())
            .map(([code, { revenue, upsellCount }]) => ({ code, value: revenue, volume: upsellCount, currency }))
            .sort((a, b) => new Date(a.code).getTime() - new Date(b.code).getTime());
        return aggregateByGranularity(data, granularity);
    }, [map, currency, granularity]);
}
